/* eslint @typescript-eslint/no-var-requires: "off" */

'use client';

import { Carousel, CarouselRenderItemInfo } from '@/components/atoms/carousel';
import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { LogoCarousel } from '.';
import { ImageCarouselStrapiProps } from '../imageWithCardsCarousel/imageWithCardsCarouselStrapi';
import { BlockWrapper } from '../utils/BlockWrapper';
import { swiperConfig } from './constants';

export type LogoCarouselStrapiProps = {
  title?: string;
  images: ImageSBProps[];
};

export function LogoCarouselStrapi({
  block,
}: BlockComponentModel<LogoCarouselStrapiProps>) {
  const { title, images } = block;
  const doubledLogos = images?.concat(images);

  const renderCarouselImage = ({
    item,
  }: CarouselRenderItemInfo<ImageCarouselStrapiProps['image']>) => (
    <LogoCarousel
      {...item}
      logo={<ImageSB block={item} inner={{ classNames: { image: '!h-4' } }} />}
    />
  );

  return (
    <BlockWrapper
      classNames={{
        root: 'py-8 md:!py-8 m:!py-[60px]',
        inner: '!max-w-[1440px]',
      }}
    >
      <div className='flex flex-col  '>
        <p className='text-body-s pb-8 md:pb-9 md:text-center'>{title}</p>
        <Carousel
          renderItem={renderCarouselImage}
          items={doubledLogos}
          config={{
            ...swiperConfig,
            loop: true,
          }}
          sideGradient={false}
          classNames={{ root: '!max-w-[1440px]' }}
        />
      </div>
    </BlockWrapper>
  );
}
